<template>
    <div>
        <div class="text-muted mb-2">Please verify the selected information:</div>
        <div class="container font-small">
            <div class="row">
                <div class="col-sm-4 font-weight-bold">Document Type:</div>
                <div class="col-sm-8">{{ documentType.name }}</div>
            </div>
            <div class="row">
                <div class="col-sm-4 font-weight-bold">Description:</div>
                <div class="col-sm-8">{{ description }}</div>
            </div>
            <div class="row">
                <div class="col-sm-4 font-weight-bold">Claim:</div>
                <div class="col-sm-8">
                    <div class="header">{{ claim.name }}</div>
                    <div v-if="claim.claim_number" class="detail">Claim Number: {{ claim.claim_number}}</div>
                    <div class="detail">Injury Date: {{ claim.injury_date }}</div>
                    <div class="detail">Provider: {{ claim.provider_name }}</div>
                </div>
            </div>
            <div v-if="documentAssociations.length">
                <div class="font-weight-bold mt-2">Associated Document(s):</div>
                <div v-for="document in documentAssociations" :key="'associated-' + document.id" class="align-middle">
                    <i v-if="document.document_status_id == DocumentStatus.AUTHORIZATION_APPROVED || document.document_status_id == DocumentStatus.AUTHORIZATION_DISPUTE_APPROVED" class="fas fa-sm fa-thumbs-up text-success"></i>
                    <i v-else-if="document.document_status_id == DocumentStatus.AUTHORIZATION_APPROVED_WITH_MODIFICATIONS" class="fas fa-sm fa-thumbs-up text-secondary"></i>
                    <i v-else-if="document.document_status_id == DocumentStatus.AUTHORIZATION_DENIED || document.document_status_id == DocumentStatus.AUTHORIZATION_DISPUTE_DENIED" class="fas fa-sm fa-thumbs-down text-danger"></i>                                 
                    <i v-else class="far fa-sm fa-question-circle text-muted"></i>
                    <span class="detail pl-1" :title="document.document_type.name + ' - ' + document.description">
                        {{ document.document_type.name }} - {{ document.description | truncate(35)}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { DocumentStatus } from '../../constants.js';

export default {
    props: {
        documentType: Object,
        description: String,
        claim: Object,
        documentAssociations: Array
    },
    data() {
        return {

            // import constants into the template
            DocumentStatus: DocumentStatus           
        }
    }
}
</script>

<style scoped>
    .font-small {
        font-size: .90rem;
    }

    .header {
        line-height: 1;
    }

    .detail {
        line-height: 1;
        font-size: .80rem;
    }

    .fa-sm {
         padding-bottom: 3px;
    }
</style>